import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { container, grid } from "./work.module.scss"
import WorkCard from "./workcard"
import { Title } from "../index"
import { themeState } from "../state"
import { useRecoilState } from "recoil"
const getData = graphql`
  {
    works: allStrapiWork {
      nodes {
        id
        slug
        title
        gallery {
          localFile {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`

const WorkGrod = () => {
  const {
    works: { nodes: work_nodes },
  } = useStaticQuery(getData)

  const [theme, setTheme] = useRecoilState(themeState)

  const workCardElements = work_nodes.map((work, index) => {
    return <WorkCard key={work.id} work={work} index={index} />
  })
  return (
    <section>
      <Title title="Previous Work" />
      <div className={grid}>{workCardElements}</div>
    </section>
  )
}

export default WorkGrod
